import * as actionTypes from "./AccountModeModalActionTypes";
import { Dispatch, UnknownAction } from "redux";

export const resetAccountModeModalAction = () => (dispatch: Dispatch<UnknownAction>) => {
  dispatch({ type: actionTypes.ACCOUNT_MODE_MODAL_RESET });
};
